module.exports = __webpack_public_path__ + "img/lot1.png";